import { z } from 'zod'
export const inviteCollaboratorSchema = z.object({
  jobId: z.string().uuid(),
  email: z.string().email(),
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
})
export type InviteCollaborator = z.infer<typeof inviteCollaboratorSchema>
